(function() {
	const headerMainMenu = document.querySelector('.header__inline-menu>.list-menu');
	if(!headerMainMenu) {
		return;
	}
	
	let exitTimer;
	const exitDelay = 250;
	
	// let justHovered = false;
	// let justHoveredTimer;
	// const dontClickAfterHoverTime = 250;
	
	function DontClickAfterHover(e) {
		// if(justHovered) {
		if(this.closest('details').open) {
			e.preventDefault();
			e.stopPropagation();
		}
	}
	
	// function EndJustHovered() {
	// 	justHovered = false;
	// 	justHoveredTimer = undefined;
	// }
	
	const headerMenuDetails = headerMainMenu.querySelectorAll(':scope>*>header-menu>details');
	function EnteredMenu(e) {
		if(exitTimer) {
			clearTimeout(exitTimer);
		}
		// if(justHoveredTimer) {
		// 	clearTimeout(justHoveredTimer);
		// }
		// justHovered = true;
		// justHoveredTimer = setTimeout(EndJustHovered, dontClickAfterHoverTime);
		for(const details of headerMenuDetails) {
			details.open = this.contains(details);
		}
	}
	function LeftMenu(e) {
		if(exitTimer) {
			clearTimeout(exitTimer);
		}
		// if(justHoveredTimer) {
		// 	clearTimeout(justHoveredTimer);
		// 	justHoveredTimer = undefined;
		// }
		// justHovered = false;
		const details = this.querySelector(':scope>header-menu>details');
		if(!details) {
			return;
		}
		exitTimer = setTimeout(() => {
			exitTimer = undefined;
			details.open = false;
		}, exitDelay);
	}
	
	for(const menu of headerMainMenu.children) {
		menu.addEventListener('mouseenter', EnteredMenu);
		menu.addEventListener('mouseleave', LeftMenu);
	}
	for(const menuDetails of headerMenuDetails) {
		const summary = menuDetails.querySelector(':scope>summary');
		summary.addEventListener('click', DontClickAfterHover, {capture: true});
	}
})();
